import { Directive, Input } from '@angular/core';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';

@Directive({})
export abstract class AvatarBaseDirective {
    @Input() userId: string;
    @Input() role: string;
    @Input() label: string;

    get shouldShowImage(): boolean {
        return !AvatarBaseDirective.avatarErrorsByUserId[this.userId];
    }

    public static avatarErrorsByUserId: { [id: string]: boolean } = {};

    get imageUrl(): string {
        const id = this.userId || '__DEFAULT__';
        return this.nomWebServicesJson.getAvatarImageUrl(id);
    }

    get backgroundUrl(): string {
        return `url('${this.imageUrl}')`;
    }

    get userName(): string {
        return this.role || this.globalTablesService.Staff?.[this.userId]?.DisplayName || this.label;
    }

    get initials(): string {
        return this.role || this.globalTablesService.Staff?.[this.userId]?.Initials || '';
    }

    onImageError() {
        AvatarBaseDirective.avatarErrorsByUserId[this.userId] = true;
    }

    imgLoaded() {
        AvatarBaseDirective.avatarErrorsByUserId[this.userId] = false;
    }

    constructor(
        public nomWebServicesJson: NomWebServicesJson,
        public globalTablesService: GlobalTablesService
    ) {}
}
